import { classNames } from 'libs/react';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { React } from 'libs/react';
import './FormRadioGroup.scss';
/**
 * @component FormRadioGroup
 * @since 1.0.0
 */
export function FormRadioGroup(props) {
    const { style, label, infos, required, optional, disabled, tooltip } = Object.assign({ style: 'normal' }, props);
    const className = classNames('form-radio-group', 'form-radio-group--' + style, { 'form-radio-group--is-required': required }, { 'form-radio-group--is-optional': optional }, { 'form-radio-group--is-disabled': disabled }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-radio-group-head" },
            label && (React.createElement(FormFieldLabel, { className: "form-radio-group-label", style: style, label: label, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
            infos && (React.createElement(FormFieldInfos, { className: "form-radio-group-infos", style: style, infos: infos }))),
        React.createElement("div", { className: "form-radio-group-body" }, props.children)));
}
